<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" :to="firstRouter" :style="{'background':logoBackground}">
        <!-- <img v-if="logo" style="" src="@/images/logo_menu2.png" class="sidebar-logo">-->
        <img v-if="minLogo" style="" :src="minLogo" class="sidebar-logo">
        <div class="min-logo-text">{{minLogoText}}</div>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" :to="firstRouter" :style="{'background':logoBackground}">
        <img class="side-max-logo" :src="sideLogo" />
        <!-- <img v-if="logo2" v-show="(logo2.indexOf('education') > 0&&orgData.title!='金州纸笔课堂')||(logo2.indexOf('business') > 0&&orgData.title!='金州纸笔课堂')" class="logo-left" src="@/images/logo_menu2.png">
        <img v-if="logo2" class="logo-right" :class="logo2.indexOf('education') > 0?'fl':logo2.indexOf('business') > 0?'fl':''" :src="logo2"> -->
        <!-- <img v-if="!logo2 && sideLogo" style="width:140px;max-height:50px;" :src="sideLogo" class="sidebar-logo">
        <div v-if="!logo2 && !sideLogo" class="side-logo-text">{{sideLogoText}}</div> -->
        <!-- <img v-if="logo" :src="logo" class="sidebar-logo"> -->
        <!-- <h1 v-if="logo" class="sidebar-title">{{ title }} </h1> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
import { getOrgInfo } from '@/api/api_url'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true,
      
    }
  },
  data() {
    return {
      title: 'Vue Admin Template',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png',
      minLogo:'',
      // logo2: '',
      sideLogo:'',
      sideLogoText:'',
      firstRouter:'/',
      minLogoText:'',
      logoBackground:'',
      orgData:{},
    }
  },
  methods:{
    getOrgInfo() {
      let hrefStr = location.href
      // let orgData = getOrgInfo('business')
      let orgData = JSON.parse(localStorage.getItem('orgType'));
      this.orgData=orgData

      // this.logo2=orgData.logo;

      // if(orgData.login_type=='5'){ //yunqi
      //   this.logo2=orgData.side_logo;
      // }


      // if(hrefStr.indexOf(orgData.domain) >= 0){     // 是政企的
      //   this.logo2 = orgData.side_logo_right
      // }else{
      //   orgData = getOrgInfo('education')
      //   this.sideLogo = orgData.side_logo
      //   if(!this.sideLogo){
      //     this.sideLogoText = orgData.title
      //   }
      //   let logo = orgData.logo
      //   if(logo.indexOf('qinglan') >=0 ){  // 青蓝联创
      //     this.logo2 = orgData.side_logo_right
      //   }
      // }
      if(orgData.side_min_logo){    // 侧边栏收起时的小logo
        this.minLogo = orgData.side_min_logo
      }else{
        this.minLogoText = orgData.title.substring(0,1)
      }
      if(orgData.side_max_logo){         // 侧边栏展开时的大logo
        this.sideLogo = orgData.side_max_logo
      }else{
        this.sideLogoText = orgData.title
      }
      if(orgData.side_logo_bg){
        this.logoBackground = orgData.side_logo_bg
      }
      let sidebarStr = localStorage.getItem('sidebarList')
      
      if(sidebarStr){
        let routesArr = JSON.parse(sidebarStr)
        this.firstRouter = routesArr[0].uri
      }
    }
  },
  mounted() {
    this.getOrgInfo()
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  // background: #282975;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.logo-left{
  float: left;
  height: 31px;
  margin: 8px 4px 0 17px;
}
.logo-right{
  // float: left;
  height: 26px;
  margin: 12px 0 0;
}
.paddingLeft{
  padding:0 0 0 20px;
}
.side-logo-text{
  height: 50px;
  padding: 0 0 0 15px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-align: left;
}
.min-logo-text{
  text-align: center;
  line-height: 54px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.fl{
  float: left;
}
.side-max-logo{
  height: 26px;
  margin: 12px 0 0;
}
</style>
